var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};
OCS.Viewer.Functions.define_CanvasLayer = function (in_implements, in_extends, options) {
    var class_definition = OCS.Viewer.Functions.define_BaseLayer(in_implements, in_extends, options);
    return new Class({
        Extends: class_definition,
        class_name: "CanvasLayer",
        canvas: null,
        canvas_info: {},
        canvas_draw_args: {},
        canvas_draw_timeout: null,
        canvas_class: null,
        drawn: false,
        palette: null,
        options: {
            auto: false, // Automatically determine the color gradient based on the incoming data max and min values.
            source_type: 'ImageCanvas'
        },
        initialize: function (op) {
            this.parent(op);
        },
        create: function () {
            var layer_ops = {};
            var source = this.get_source();
            if (source) {
                layer_ops.source = source;
            }

            var layer = new ol.layer.Image(layer_ops);
            this.set_layer(layer);
            return layer;
        },
        on_render: function (src) {
            this.fireEvent('render', src);
        },
        on_draw_finish: function (src) {
            this.fireEvent(OCS.Viewer.Config.events.LAYER_DRAW_FINISH, [src, this]);
        },
        set_source_obj: function (source) {
            if (source && source.class_type === "Source" && (source.class_name === "ImageCanvasSource" || source.class_name === "GradientImageCanvasSource" || source.class_name === "RadarImageCanvasSource")) {
                source.addEvent('render', this.on_render.bind(this));
                source.addEvent(OCS.Viewer.Config.events.LAYER_DRAW_FINISH, this.on_draw_finish.bind(this));
                if(this.get_canvas_info && this.get_pixel_from_coordinate) {
                    source.get_canvas_info = this.get_canvas_info;
                    source.get_pixel_from_coordinate = this.get_pixel_from_coordinate;
                }
                
                this.parent(source);
            }
        },
        set_canvas_draw_methods: function(cnv_info, get_pixel_from_coordinate) {
            if(this.source_obj) {
                this.source_obj.get_canvas_info = cnv_info;
                this.source_obj.get_pixel_from_coordinate = get_pixel_from_coordinate;
            } else {
                this.get_pixel_from_coordinate = get_pixel_from_coordinate;
                this.get_canvas_info = cnv_info;
            }
        },
        get_palette: function () {
            var src = this.get_source_obj();
            if (src) {
                return src.get_palette();
            }
        },
        layer_has_data: function () {
            var source_obj = this.get_source_obj();
            if (source_obj) {
                var data = source_obj.get_data();
                if (data) {
                    return true;
                }
            }
            return false;
        },
        is_drawn: function () {
            var source = this.get_source_obj();
            if (source) {
                return source.drawn;
            }
            return false;
        },
        set_drawn: function (val) {
            var source = this.get_source_obj();
            if (source)
                source.drawn = val;
        },
        delete: function () {
            var source = this.get_source_obj();
            if (source) {
                source.destroy();
            }
            this.parent();
        }
    });
};
OCS.Viewer.Classes.CanvasLayer = OCS.Viewer.Functions.define_CanvasLayer();

